import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import Link from '@alltrails/denali/components/Link';
import styles from './PressAssetRequestNote.module.scss';

type Props = {
  className?: string;
};

export default function PressAssetRequestNote({ className }: Props) {
  return (
    <Typography className={classNames(styles.note, className)} color="secondary" component="p" variant="text100">
      <FormattedMessage
        defaultMessage="Please reach out to <a>press@alltrails.com</a> for additional asset requests."
        values={{
          a: chunks => (
            <Link href="mailto:press@alltrails.com" variant="secondary">
              {chunks}
            </Link>
          )
        }}
      />
    </Typography>
  );
}
